import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';

export const REPORTES_MENU: AppMenuItem =   {
  "label": "Reportes",
  "visible": true,
  "children": [
  {
    "ambientes": [
      AmbienteEnum.Desarrollo,
      AmbienteEnum.Calidad
    ],
    "sociedades": [
      SociedadEnum.SC,
      SociedadEnum.MX,
      SociedadEnum.VU
    ],
    "label": "Consulta Registro de Personal",
    "route": "reportes/consulta-registro-personal",
    "tipoPuntoVenta": [
      TipoPuntoVentaEnum.Corporativo,
      TipoPuntoVentaEnum.PuntoVentaPropio,
      TipoPuntoVentaEnum.Franquicias
    ],
    "visible": true
  },
  {
    "ambientes": [
      AmbienteEnum.Desarrollo,
      AmbienteEnum.Calidad
    ],
    "sociedades": [
      SociedadEnum.SC,
      SociedadEnum.MX,
      SociedadEnum.VU
    ],
    "label": "Consulta Ventas",
    "route": "reportes/consulta-ventas",
    "tipoPuntoVenta": [
      TipoPuntoVentaEnum.Corporativo,
      TipoPuntoVentaEnum.PuntoVentaPropio,
      TipoPuntoVentaEnum.Franquicias
    ],
    "visible": true
  }
]
}
